import { DateBadgeProps } from './date-badge.component';

interface ViewProps {
    date?: string;
    time?: string;
}

const useDateBadge = (props: DateBadgeProps): ViewProps => {
    const date = props.date ? new Date(props.date).toLocaleDateString() : 'Unknown';
    const time = props.displayTime && props.date ? new Date(props.date).toLocaleTimeString() : 'Unknown';
    return {
        date,
        time
    };
};

export default useDateBadge;
